import styled from "styled-components";
import bg from "assets/login_bg.svg";

/** 登录中转页：已无账号密码表单，只展示品牌信息与跳转/校验进度 */
export const StyledLoginPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: auto;
  text-align: center;
  background: #f0f2f5;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-position: center 110px;
  background-size: 100%;

  .title {
    font-weight: 700;
    font-size: 2em;
    color: rgba(0, 0, 0, 0.85);
  }

  .state {
    margin-top: 0.5em;
    margin-bottom: 2em;
    font-size: 1em;
    color: rgba(0, 0, 0, 0.45);
  }

  .tip {
    margin-top: 1em;
    color: rgba(0, 0, 0, 0.45);
  }
`;
